import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { RootState } from '../store';
import { ProfileDTO2 } from '../../api/api';

export interface UserProfileState {
  userProfile: ProfileDTO2;
  isLoaded: boolean;
}

const initialState: UserProfileState = {
  userProfile: {
    department: undefined,
    firstLoad: undefined,
    role: undefined,
    defaultWarehouseId: undefined,
    vehicle: undefined,
    name: undefined,
    isAutomaticNotificationsEnabled: undefined
  },
  isLoaded: false
};

const userProfileSlice = createSlice({
  name: 'userProfile',
  initialState: initialState,
  reducers: {
    setUserProfileState: (state: UserProfileState, action: PayloadAction<ProfileDTO2>) => {
      state.userProfile = action.payload;
      state.isLoaded = true;
    }
  }
});

export const { setUserProfileState } = userProfileSlice.actions;
export const selectUserProfile = (state: RootState) => state.userProfile;

export default userProfileSlice.reducer;
